import React from 'react';
import './Settings.css';

const Settings = ({ toggleTheme, theme }) => {
  return (
    <div className="WSNG-settings-container">
      <div className="WSNG-settings-section">
        <h2>Appearance</h2>
        <div className="WSNG-setting-item">
          <div className="WSNG-setting-info">
            <label className="WSNG-setting-label">Theme Mode</label>
            <p className="WSNG-setting-description">
              Switch between dark and light theme
            </p>
          </div>
          <button
            onClick={toggleTheme}
            className={`WSNG-theme-toggle ${theme === 'light' ? 'light' : 'dark'}`}
          >
            <div className="WSNG-toggle-slider">
              <i className={`fas ${theme === 'light' ? 'fa-sun' : 'fa-moon'}`}></i>
            </div>
            <span className="WSNG-toggle-label">
              {theme === 'light' ? 'Light' : 'Dark'}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Settings;
